// BHP-1050: React Query hook for the current user's account (Backend2.0).
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchCurrentAccount } from './accountApi';
import type { AccountData } from '../domain/accountData';

export const accountKeys = {
  current: ['account', 'current'] as const
};

export function useCurrentAccount(): UseQueryResult<AccountData | null> {
  return useQuery({
    queryKey: accountKeys.current,
    queryFn: fetchCurrentAccount
  });
}
